import { Button } from '../SideBar/Menu.style'
import {
  ContainerTitleInativaOrganizacao,
  ButtonsCancelarPedido,
  Container,
  Modal,
} from './styles'

type CancelaPedidoProps = {
  texto: string
  botaoNao: () => void
  botaoSim: () => void
}

export function CancelaPedido({
  botaoNao,
  texto,
  botaoSim,
}: CancelaPedidoProps) {
  return (
    <Container>
      <Modal>
        <ContainerTitleInativaOrganizacao>
          {texto}
        </ContainerTitleInativaOrganizacao>
        <ButtonsCancelarPedido>
          <Button
            inativarOrganizacaoSim
            buttonType="SMALL"
            type="button"
            onClick={() => {
              botaoNao()
              botaoSim()
            }}
          >
            Sim
          </Button>
          <Button
            inativarOrganizacaoNao
            buttonType="SMALL"
            type="button"
            onClick={() => {
              botaoNao()
            }}
          >
            Não
          </Button>
        </ButtonsCancelarPedido>
      </Modal>
    </Container>
  )
}
